import $http from "@/helpers/api";
import {
    objectToFormData
} from "@/helpers/formdata";

// initial state
const state = {
    all: [],
    document: [],
    download: {}
};

// getters
const getters = {
    get: state => state.document,
    getAll: state => state.all
};

// actions
const actions = {
    getAll({
        commit
    }) {
        return new Promise((resolve, reject) => {
            $http.get("/documents").then(resp => {
                commit("setAll", resp.data.documents);
            });
            resolve();
        });
    },
    get({
        commit
    }, documentId) {
        return new Promise(resolve => {
            $http.get("/documents/" + documentId).then(resp => {
                commit("set", resp.data.document);
                resolve();
            });
        });
    },
    add(context, data) {
        let form_data = objectToFormData(data);
        return new Promise((resolve, reject) => {
            $http.post("/documents", form_data, {
                headers: {
                    "content-type": "multipart/form-data"
                }
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    edit({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            $http.put("/documents/" + data.id, {
                document: data
            }).then(resp => {
                commit("clear");
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    search(context, data) {
        return new Promise((resolve, reject) => {
            $http.get("/documents", {
                params: data
            }).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    delete({}, data) {
        return new Promise((resolve, reject) => {
            $http.delete("/documents/" + data).then(resp => {
                resolve(resp);
            }).catch(error => {
                reject(error);
            });
        });
    },
    forceFileDownload({
        state
    }, response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", state.download.oldname); //or any other extension
        link.setAttribute("target", "_blank"); //or any other extension
        document.body.appendChild(link);
        link.click();
    },
    download({
        state,
        dispatch
    }, data) {
        $http({
            method: "get",
            url: "/documents/download/" + data.id,
            responseType: "arraybuffer"
        }).then(response => {
            state.download = data;
            dispatch("forceFileDownload", response);
        }).catch(error => {
            console.log(error);
        });
    }
};

// mutations
const mutations = {
    setAll(state, documents) {
        state.all = documents;
    },
    set(state, document) {
        state.document = document;
    },
    clear(state) {
        state.document = [];
    },
    clearAll(state) {
        state.document = [];
        state.all = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
